import { Dropdown } from "primereact/dropdown";
import styled from "styled-components";

export const TableFooter = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 70px;
  display: flex;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
  background: #ffffff;

  .p-paginator {
    width: 100%;
    min-height: 70px;
    display: grid;
    grid-template-columns: minmax(180px, 1fr) auto auto auto minmax(220px, 1fr);
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    background: transparent;
    color: #181818;
    border: 0;
  }

  .p-paginator-first,
  .p-paginator-last {
    display: none;
  }

  .p-paginator-current {
    justify-self: start;
  }

  .p-paginator-prev {
    grid-column: 2;
  }

  .p-paginator-pages {
    grid-column: 3;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .p-paginator-next {
    grid-column: 4;
  }

  .p-paginator > :last-child {
    grid-column: 5;
    justify-self: end;
  }

  @media (max-width: 768px) {
    .p-paginator {
      grid-template-columns: 1fr;
      justify-items: stretch;
    }

    .p-paginator-current,
    .p-paginator-prev,
    .p-paginator-pages,
    .p-paginator-next,
    .p-paginator > :last-child {
      grid-column: 1;
      justify-self: center;
    }
  }
`;

export const HeaderControls = styled.div<{ $spread?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 24px;
  min-width: 0;
  flex-wrap: wrap;

  ${({ $spread }) => $spread && "width: 100%;"}
`;

export const HeaderSpacer = styled.div`
  flex: 1 1 auto;
`;

export const TableHeader = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
  background: #ffffff;
`;

export const PageReportTitle = styled.span`
  color: #181818;
  user-select: none;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`;

export const PaginatorBtn = styled.button`
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #181818;
  cursor: pointer;

  &:disabled {
    color: #9fa0a4;
    cursor: default;
  }

  &:not(:disabled):hover {
    background-color: #ebf4ff;
    color: #065fa6;
  }
`;

export const PaginatorPageButton = styled.button<{ $isCurrent: boolean }>`
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${({ $isCurrent, theme }) =>
      $isCurrent ? theme.searchPatients.controls.tabOutline : "transparent"};
  border-radius: 8px;
  background: ${({ $isCurrent }) => ($isCurrent ? "#ffffff" : "transparent")};
  color: #181818;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    background-color: #ebf4ff;
    color: #065fa6;
  }
`;

export const RowsPerPageWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-height: 38px;
  color: #181818;
`;

export const RowsPerPageLabel = styled.span`
  color: #181818;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  user-select: none;
`;

export const RowsPerPage = styled(Dropdown)`
  min-width: 88px;

  &.p-dropdown {
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-radius: 8px;
    box-shadow: none;
    background: #ffffff;
    height: 38px;
  }

  & .p-dropdown-label {
    padding: 8px 8px 8px 12px;
    color: #181818;
    font-size: 14px;
    line-height: 20px;
  }

  & .p-dropdown-trigger {
    width: 32px;
    color: #5a5959;
  }

  &:not(.p-disabled).p-focus,
  &:not(.p-disabled):hover {
    border-color: #065fa6;
    box-shadow: 0 0 0 1px rgba(6, 95, 166, 0.12);
  }
`;
